import { apiProvider } from "./core/provider";

const apiScheduler = {};

// from/to are YYYY-MM-DD. Returns { days: [{ date, entries: [...] }] }.
apiScheduler.getCalendar = function (from, to) {
  return apiProvider.get(`scheduler/calendar?from=${from}&to=${to}`);
};

// per-user scheduler prefs (server-side, UserPreferences).
apiScheduler.getPreferences = function () {
  return apiProvider.get(`scheduler/preferences`);
};

apiScheduler.savePreferences = function (hiddenAreas) {
  return apiProvider.put(`scheduler/preferences`, { hiddenAreas });
};

export { apiScheduler };